const template = require('./country_options_foreign_pills.html.slim');
const controller = require('./country_options_foreign_pills_controller');

// Superseded by ng2 CountryListComponent (selector: input-countrylist)
angular.module('wbComponents').directive('wbCountryForeignOptionsPills', () => ({
  scope: {
    model: '=',
    otherCountryRadio: '='
  },
  restrict: 'E',
  replace: true,
  require: '?ngModel',
  templateUrl: template,
  controller,
  controllerAs: 'ctrl'
}));
